import Categories from '@/components/category/Categories'
import CategoriesNew from '@/components/category/CategoriesNew'
import CategoriesEdit from '@/components/category/CategoriesEdit'
export default [
  {
    path: '/category',
    name: 'category',
    component: Categories,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/category/new',
    name: 'categoryNew',
    component: CategoriesNew,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/category/:id/edit',
    name: 'categoryEdit',
    component: CategoriesEdit,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/categoryRoutes.js